// Registration data model
export class RegistrationData {
  constructor({
    email = "",
    name = "",
    lastName = "",
    password = "",
    dni = "",
    birthdate = "",
    nationality = "",
    gender = "",
    phone = "",
    address = "",
    postalCode = "",
    city = "",
    country = "",
    sobreMi = "",
    observaciones = "",
    necesidades = "",
  }) {
    this.email = email;
    this.name = name;
    this.lastName = lastName;
    this.password = password;
    this.dni = dni;
    this.birthdate = birthdate;
    this.nationality = nationality;
    this.gender = gender;
    this.phone = phone;
    this.address = address;
    this.postalCode = postalCode;
    this.city = city;
    this.country = country;
    this.sobreMi = sobreMi;
    this.observaciones = observaciones;
    this.necesidades = necesidades;
  }

  toJson() {
    return {
      email: this.email,
      name: this.name,
      lastName: this.lastName,
      password: this.password,
      dni: this.dni,
      birthdate: this.birthdate,
      nationality: this.nationality,
      gender: this.gender,
      phone: this.phone,
      address: this.address,
      postalCode: this.postalCode,
      city: this.city,
      country: this.country,
      sobreMi: this.sobreMi,
      observaciones: this.observaciones,
      necesidades: this.necesidades,
    };
  }
}
